import React from 'react';
import Layout from '../components/layout';
import CoverImage from '../components/CoverImage/CoverImage'

export default ({pageContext}) => (
    <Layout>
        <CoverImage text={pageContext.title} image="https://smorasstats.com/v4/wp-content/uploads/2020/04/meadow-grass-sunshine-wide-scaled.jpg" />
        <div className="">
            
            <div className="row no-gutters">
                <div className="col-md-4 col-lg-2">
                    <img src={pageContext.featured_media.source_url} alt="featured_image" className="img-fluid" />
                </div>
                <div className="col-md-8 col-lg-10 player-details-column text-white p-4">
                    <table className="table table-borderless text-white player-table">
                        <tr>
                            <td>Klubb</td>
                            <td >{!pageContext.acf.tilhorende_lag ? pageContext.acf.hovedlag : pageContext.acf.tilhorende_lag}</td>
                        </tr>
                        <tr>
                            <td>Posisjon</td>
                            <td>{pageContext.acf.posisjon}</td>
                        </tr>
                        <tr>
                            <td>Draktnummer</td>
                            <td>{pageContext.acf.draktnummer}</td>
                        </tr>
                        <tr>
                            <td>Kamper</td>
                            <td>{pageContext.acf.antall_kamper}</td>
                        </tr>
                        <tr>
                            <td>Mål</td>
                            <td>{pageContext.acf.antall_mal}</td>
                        </tr>
                        <tr>
                            <td>Assist</td>
                            <td>{pageContext.acf.antall_assist}</td>
                        </tr>
                    </table>
                </div>
                
            </div>

            <div dangerouslySetInnerHTML={{__html: pageContext.content}}></div>
        </div>
    </Layout>

);
